import React, { useState } from "react";
import AlertDialog from "./Components/AlertDialog";
import { useHistory } from "react-router-dom";
import useErrorMutation from "./useErrorMutation";
import useAccountSettings from "./ManageAccount/useAccountSettings";
import { useTranslation } from "react-i18next";

const ErrorBoundary = ({ children }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [error, setError] = useState(null);

  const { accountSettings } = useAccountSettings();
  const errorMutation = useErrorMutation();

  const handleError = (error) => {
    setError(error);
    errorMutation.mutate({
      errorMessage: error.message,
      stack: error.stack,
      code: accountSettings.code,
    });
  };

  const handleClearError = () => setError(null);

  const handleRestart = () => {
    handleClearError();
    history.push({ pathname: "/home" });
  };

  const handleRetry = () => {
    handleClearError();
  };

  return error ? (
    <AlertDialog
      dialogTitle={t("common.errors.errorDialog.title")}
      dialogContentText={t("common.errors.errorDialog.retryMessage")}
      dialogActionCancel={t("common.errors.errorDialog.goToHome")}
      cancelFunction={handleRestart}
      dialogActionConfirm={t("common.errors.errorDialog.retry")}
      confirmFunction={handleRetry}
    />
  ) : (
    <ErrorCatcher onError={handleError}>{children}</ErrorCatcher>
  );
};

class ErrorCatcher extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    this.props.onError(error);
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

export default ErrorBoundary;
